import type { DpProvider } from '@/core/di/DpProvider';
import { EventTrackerFacade } from '@/common/tracking-event/public/api';
import { delay, injectable } from 'tsyringe';
import type { DependencyContainer } from 'tsyringe';
import type { EventTracker } from '../../domain/tracking/EventTracker';
import { EventTrackerToken } from '../tokens';

@injectable()
export class EventTrackerProvider implements DpProvider {
  register(container: DependencyContainer): void {
    container.register<EventTracker>(EventTrackerToken, {
      useToken: delay(() => EventTrackerFacade),
    });
  }
}
